export function isTestAccountRegistered(id) {
  return id >= 50000 && ![88888, 99999].includes(id);
}
